const isDev: boolean = process.env.NODE_ENV === 'development';

type LogMethod = (...args: unknown[]) => void;

interface Logger {
  log: LogMethod;
  info: LogMethod;
  warn: LogMethod;
  error: LogMethod;
}

const logger: Logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log('[LOG]:', ...args);
  },
  info: (...args: unknown[]) => {
    if (isDev) console.info('[INFO]:', ...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn('[WARN]:', ...args);
  },
  error: (...args: unknown[]) => {
    if (isDev) console.error('[ERROR]:', ...args);
  },
};

export default logger;